module.exports = __webpack_public_path__ + "static/img/modelingCaseBanner.b7df36a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modelingCaseBanner.png
// module id = 7ITe
// module chunks = 2